document.addEventListener("DOMContentLoaded", function() {
    const list_switch = document.getElementById('list-switch')
    const list_el = document.getElementById('releases-list');

    if(list_switch && list_el){
        list_switch.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('list-view');
            list_el.classList.toggle('list-view');
        }
    }
});

document.addEventListener("turbo:render", function() {
    const list_switch = document.getElementById('list-switch')
    const list_el = document.getElementById('releases-list');

    if(list_switch && list_el){
        list_switch.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('list-view');
            list_el.classList.toggle('list-view');
        }
    }
});